import React, { ReactChild, FunctionComponent } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { queryClient as defaultQueryClient } from '../../services/queryClient';

interface Props {
  children: ReactChild;
  queryClient?: QueryClient;
}

export const SEOToolsQueryProvider: FunctionComponent<Props> = ({ queryClient, children }) => {
  return <QueryClientProvider client={queryClient ?? defaultQueryClient}>{children}</QueryClientProvider>;
};
